export default __webpack_public_path__ + "static/media/README.0a8ef593.md";